module.exports = __webpack_public_path__ + "static/media/Seguridad.b0dc0a21.png";